export default "__VITE_ASSET__DUU8dcto__"